export enum RoleEnum {
  PROFESSOR = 3,
  ADMIN = 4,
  DIRETOR = 5,
  SECRETARIO = 6,
  RESPONSAVEL = 7,
  AUTHENTICATED = 1,
}

export enum PermissaoEnum {
  ROLE_DEFAULT = 2,
  ROLE_ADMIN = 4,
  ROLE_DIRETOR = 6,
  ROLE_SECRETARIO = 8,
  ROLE_PROFESSOR = 10,
  ROLE_RESPONSAVEL = 12,
  ROLE_SUPPORT = 14
}

export interface Role {
  id: number;
  documentId: string;
  name: string;
  description: string;
  type: string;
  createdAt: string; // ISO Date string
  updatedAt: string; // ISO Date string
  publishedAt: string; // ISO Date string
}

export interface Roles {
  roles: Role[];
}

export interface Permissao {
  id: number;
  documentId: string;
  role: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export interface permissaoBehavior {
  id: number;
  label: string;
  documentId: string;
}
